import AirbrakeJs from 'airbrake-js'

import Core from '../Core'

class FakeAirbrakeJs {
  notify () {}
}

let airbrake
if (process.env.NODE_ENV === 'test') {
  airbrake = new FakeAirbrakeJs()
} else {
  airbrake = new AirbrakeJs({
    projectId: 136963,
    projectKey: '7b66982a02467de7578a37d5ccb5dde3',
    environment: process.env.API_ENV,
    ignoreWindowError: true,
    // unwrapConsole: true,
  })
  airbrake.addFilter((notice) => {
    if (process.env.NODE_ENV === 'development' || process.env.API_ENV === 'test') {
      console.error('Airbrake', notice)
      return null
    }
    notice.context.environment = process.env.API_ENV
    notice.context.version = require('../../package').version
    notice.context.regionCode = Core.get('__REGION_CODE__')
    return notice
  })
}

export default airbrake
